import { DashboardJobsStatus, DashboardJobsType } from '~/domain/DashboardJobs';
import { FilterStatusEnum } from '~/utils/Enum';
import { ShiftOverviewTab } from '../ShiftOverviewTab';

export const ScheduledTab = ({ jobType }: { jobType: DashboardJobsType }) => (
  <ShiftOverviewTab
    jobType={jobType}
    listStatus={DashboardJobsStatus.FILLED}
    cardStatus="scheduled"
    dataCy="scheduled-shifts-grid"
    emptyType={FilterStatusEnum.SCHEDULED}
    cardClickTo={(item) => `/dashboard/job/${item.id}`}
    chatTo={(item) => `/dashboard/chat/${item.id}`}
    canCancel
  />
);
